import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Stack, Divider, Pagination } from '@mui/material';
import Sidebar from '../Layout/SideBar';
import { getAllAccounts } from '../../models/Account';

export default function DashboardAccount() {
    const [accounts, setAccounts] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const pageSize = 10;

    const fetchAccounts = async () => {
        try {
            const res = await getAllAccounts();
            if (res) {
                setAccounts(res);
                setTotalPages(Math.ceil(res.length / pageSize));
            }
        } catch (err) {
            console.error('Error fetching accounts:', err);
        }
    };

    useEffect(() => {
        fetchAccounts();
    }, []);
    console.log(accounts);

    const getAvatarUrl = (acc) => {
        if (!acc) return `https://ui-avatars.com/api/?name=Anon&background=random`;

        if (acc.avatar) {
            return `${process.env.REACT_APP_STATIC_URL}${acc.avatar}`;
        }
        return `https://ui-avatars.com/api/?name=${encodeURIComponent(
            acc.username || 'Anon'
        )}&background=random`;
    };

    const startIndex = (page - 1) * pageSize;
    const paginatedAccounts = accounts.slice(startIndex, startIndex + pageSize);

    return (
        <Box display="flex">
            <Sidebar />
            <Box flexGrow={1} p={3}>
                <Typography variant="h5" gutterBottom fontWeight="bold">
                    Quản lý tài khoản
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                    Tổng số tài khoản: <b>{accounts.length}</b>
                </Typography>

                {paginatedAccounts.map((acc) => (
                    <Paper
                        key={acc.id}
                        sx={{ p: 2, mb: 2, bgcolor: '#fafafa', border: '1px solid #ddd' }}
                        elevation={1}
                    >
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={2}
                            justifyContent="space-between"
                            alignItems={{ xs: 'flex-start', sm: 'center' }}
                        >
                            <Stack direction="row" spacing={1} alignItems="center">
                                <img
                                    src={getAvatarUrl(acc)}
                                    alt={acc.username || 'Ẩn danh'}
                                    width={28}
                                    height={28}
                                    style={{ borderRadius: '50%' }}
                                />
                                <Typography variant="subtitle1" fontWeight="bold" color="primary">
                                    {acc.username} - {acc.email}
                                </Typography>
                            </Stack>
                        </Stack>

                        <Divider sx={{ my: 1 }} />

                        <Box sx={{ mt: 1, color: 'text.primary' }}>
                            <Typography variant="body2">
                                Vai trò:{' '}
                                <b>
                                    {acc.role === 'admin' ? 'Quản trị viên' : 'Người dùng'}
                                </b>
                            </Typography>
                        </Box>

                    </Paper>
                ))}

                <Box display="flex" justifyContent="center" mt={2}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                    />
                </Box>
            </Box>
        </Box>
    );
}
